import type { ParamMap, Params } from '@angular/router';

/** A detail's tenant identifies its request; listTenant remembers the independently chosen filter. */
export const LIST_TENANT_PARAM = 'listTenant';
const ALL_TENANTS = 'all';

/** Errors opens the same request investigation while retaining its originating collection. */
export function collectionPath(params: ParamMap): 'requests' | 'errors' {
  return params.get('listView') === 'errors' ? 'errors' : 'requests';
}

function filterTenant(value: string | null): string | null {
  const normalized = value?.trim() ?? '';
  return /^[1-9]\d*$/.test(normalized) && Number(normalized) <= 2_147_483_647 ? normalized : null;
}

/** Merge into a row/detail/thread link. Other filters and cost mode stay in the current query. */
export function entityNavigationQuery(
  params: ParamMap,
  tenant: string | null,
  fromCollection = false,
): Params {
  const returnTenant = filterTenant(params.get(fromCollection ? 'tenant' : LIST_TENANT_PARAM));
  return {
    tenant,
    [LIST_TENANT_PARAM]: returnTenant ?? ALL_TENANTS,
    listView: !fromCollection && collectionPath(params) === 'errors' ? 'errors' : null,
    tab: null,
    step: null,
    turn: null,
  };
}

/** Direct entity URLs have no chosen list filter, so return to all tenants unless recorded explicitly. */
export function collectionNavigationQuery(params: ParamMap, fromEntity = true): Params {
  return {
    tenant: filterTenant(params.get(fromEntity ? LIST_TENANT_PARAM : 'tenant')),
    [LIST_TENANT_PARAM]: null,
    listView: null,
    tab: null,
    step: null,
    turn: null,
  };
}
